export default "__VITE_ASSET__J3sVXQFL__"